// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import "firebase/auth";
import "firebase/firestore";

import * as reactRedux from "react-redux";
import * as redux from "redux";

import { AuthAction, authReducer, subscribeToAuthState } from "./auth";
import { ConfigAction, configReducer } from "./config";
import { FedExAction, fedExReducer } from "./fedex";
import { PhotoUploadAction, photoUploadReducer } from "./photoUpload";
import { TestRunAction, testRunReducer } from "./testrun";
import thunk, { ThunkAction, ThunkDispatch } from "redux-thunk";

export type Action =
  | AuthAction
  | ConfigAction
  | PhotoUploadAction
  | FedExAction
  | TestRunAction;
type Store = redux.Store<RootState, Action>;

let globalStore: Store | null = null;
export function getStore(): Store {
  if (globalStore === null) {
    globalStore = redux.createStore(rootReducer, redux.applyMiddleware(thunk));

    subscribeToAuthState(globalStore);
  }

  return globalStore;
}

// --------------------------------------------------------------------------
// Useful selectors
// --------------------------------------------------------------------------

export const useSelector: reactRedux.TypedUseSelectorHook<RootState> =
  reactRedux.useSelector;
export function useShallowEqualSelector<TSelected>(
  selector: (state: RootState) => TSelected
): TSelected {
  return useSelector(selector, reactRedux.shallowEqual);
}

// --------------------------------------------------------------------------
// Root reducer
// --------------------------------------------------------------------------
const rootReducer = redux.combineReducers({
  auth: authReducer,
  config: configReducer,
  photoUpload: photoUploadReducer,
  fedEx: fedExReducer,
  testRun: testRunReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  redux.Action<string>
>;
export type AppDispatch = ThunkDispatch<RootState, any, Action>;
export function useAppDispatch(): AppDispatch {
  return reactRedux.useDispatch();
}
